//import React from "react";
/*
import '../App.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

//import Appointment from"./Appointment";
import NewsPage from "./NewsPage";


import QuickInfo from "./Quickinfo";
import VerifyVin from "./VerifyVin";
import MREdata from "./MREdb";
import OurService from "./Ourservice";
import PriceList from "./Pricelist";/*display pricelist as a table*//*
//import PriceList from "./price";
import NewModelReport from "./NewModelReport";/* page to display the new model report as a table*//*
import TopModel from "./TopSellingModel";
//import Newreport from"./NewModelReportsNew";
import HeroSection from "./HeroPage";
import Contact from "./Contact";
import SevExpiry from "./SevExpiry";
import React, { useRef, useEffect} from 'react';
import Advertisement from "./AdvertisementSection";
import NewsBanner from "./NewsBanner";



const Home =({ darkMode }) =>{

    const NextRef = useRef(null);

  const scrollToNext = () => {
    
    NextRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

   return (

    <div className="home-wrapper">
    <div className ="container-fluid mt-4">
      
       <div  ref={NextRef}  id="Home_Section" className="container-fluid scroll-target pt-5 mt-5">
        <HeroSection darkMode={darkMode} onGetStartedClick={scrollToNext}/>
        </div>
        
        <div  ref={NextRef}  id="SEVExpiry" className="container-fluid scroll-target pt-5 mt-5"> 
  
        <SevExpiry darkMode={darkMode}/> 
  
           
        </div>

        <div  ref={NextRef}  id="NewReport"  className="container-fluid scroll-target   p-0 m-0 d-flex justify-content-center align-items-center" 
  style={{
    height: '100vh', /* Makes the container cover 100% of the viewport height *//*
  overflow: 'hidden', /* Prevents unwanted scrollbars *//*
    scrollPaddingBottom: '100px', 
   scrollMarginBottom: '50px'
  }}
>
  
   
       <NewModelReport darkMode={darkMode} />
        </div> 

        <div  ref={NextRef}  id="VerifyVIN" className="container-fluid  scroll-target pt-5 mt-5" style={{ scrollPaddingBottom: "100px", scrollMarginBottom: "-80px" }}>
             
             <VerifyVin  darkMode={darkMode}/>
        </div> 

        <div  ref={NextRef}  id="TopModel" className="container-fluid d-flex justify-content-center align-items-center p-0 m-0 scroll-target bg-light text-white" 
  style={{
    height: '100vh', /* Ensures the container takes up the full viewport height *//*
    overflow: 'hidden', /* Prevents any scrollbars from showing *//*
    scrollPaddingTop: '100px', /* Custom scroll padding *//*
    scrollMarginTop: '50px' /* Custom scroll margin *//*
  }}
>
          <TopModel darkMode={darkMode}/>
        </div> 

        <div className=" container-fluid scroll-target py-5 my-5" style={{ scrollPaddingtop: "100px", scrollMargintop: "-80px" }}>
            <OurService darkMode={darkMode} /> 
        </div>


        <div ref={NextRef}  id="PriceList" className="container-fluid scroll-target pt-5 mt-5"style={{ scrollPaddingtop: "100px", scrollMargintop: "-80px" }}> 
         <PriceList darkMode={darkMode}/>   
         </div>
        <div  ref={NextRef}  id="MREdata" className="container-fluid scroll-target pt-5 mt-5"style={{ scrollPaddingtop: "100px", scrollMargintop: "-80px" }}>
         <MREdata darkMode={darkMode}/>  
        </div> 
         
     <div  ref={NextRef}  id="Adverisemet" className="container-fluid scroll-target pt-5 mt-5 "style={{ scrollPaddingtop: "100px", scrollMargintop: "-80px" }}> 
          <Advertisement darkMode={darkMode}/> 
        </div>      

 <div ref={NextRef}  id="Enquiry_Section" className="container-fluid d-flex justify-content-center align-items-center p-0 m-0 scroll-target" 
  style={{
    height: '100vh', /* Ensure the section covers the full viewport height *//*
    overflow: 'hidden', /* Prevent overflow *//*
    scrollPaddingTop: '100px', /* Customize scroll padding *//*
    scrollMarginTop: '50px' /* Customize scroll margin *//*
  }}
>


 <Contact darkMode={darkMode}/>
   
 </div>
  
    </div>
    </div>
   );
}


export default Home;*/








import React, { useRef, useEffect } from 'react';
import '../App.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import QuickInfo from "./Quickinfo";
import VerifyVin from "./VerifyVin";
import MREdata from "./MREdb";
import OurService from "./Ourservice";
//import PriceList from "./Pricelist";
import NewModelReport from "./NewModelReport";
import TopModel from "./TopSellingModel";
import HeroSection from "./HeroPage";
import Contact from "./Contact";
import SevExpiry from "./SevExpiry";
import Advertisement from "./AdvertisementSection";
import NewsBanner from "./NewsBanner";

const Home = ({ darkMode, setActiveLink }) => {

    const NextRef = useRef(null);

    const scrollToNext = () => {
        NextRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    // ONLY this useEffect is added to fix the "Paste Link" problem
    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            // We wait just a moment for your components to finish rendering
            const timer = setTimeout(() => {
                const id = hash.replace('#', '');
                const element = document.getElementById(id);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                    
                    // Sync the navbar state
                  //  if (id === 'PriceList' && typeof setActiveLink === 'function') {
                      //  setActiveLink('Pricing');
                   // }
                }
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [setActiveLink]);

    return (
        <div className="home-wrapper">
            <div className="container-fluid mt-4">
                
                <div ref={NextRef} id="Home_Section" className="container-fluid scroll-target pt-5 mt-5">
                    <HeroSection darkMode={darkMode} onGetStartedClick={scrollToNext}/>
                </div>
                
                <div ref={NextRef} id="SEVExpiry" className="container-fluid scroll-target pt-5 mt-5"> 
                    <SevExpiry darkMode={darkMode}/> 
                </div>

                <div ref={NextRef} id="NewReport" className="container-fluid scroll-target p-0 m-0 d-flex justify-content-center align-items-center" 
                    style={{ height: '100vh', overflow: 'hidden', scrollPaddingBottom: '100px', scrollMarginBottom: '50px' }}>
                    <NewModelReport darkMode={darkMode} />
                </div> 

                <div ref={NextRef} id="VerifyVIN" className="container-fluid scroll-target pt-5 mt-5" 
                    style={{ scrollPaddingBottom: "100px", scrollMarginBottom: "-80px" }}>
                    <VerifyVin darkMode={darkMode}/>
                </div> 

                <div ref={NextRef} id="TopModel" className="container-fluid d-flex justify-content-center align-items-center p-0 m-0 scroll-target bg-light text-white" 
                    style={{ height: '100vh', overflow: 'hidden', scrollPaddingTop: '100px', scrollMarginTop: '50px' }}>
                    <TopModel darkMode={darkMode}/>
                </div> 

                <div className="container-fluid scroll-target py-5 my-5" 
                    style={{ scrollPaddingtop: "100px", scrollMargintop: "-80px" }}>
                    <OurService darkMode={darkMode} /> 
                </div>

                {/*<div ref={NextRef} id="PriceList" className="container-fluid scroll-target pt-5 mt-5"
                    style={{ scrollPaddingtop: "100px", scrollMargintop: "-80px" }}> 
                    <PriceList darkMode={darkMode}/>   
                </div>*/}

                <div ref={NextRef} id="MREdata" className="container-fluid scroll-target pt-5 mt-5"
                    style={{ scrollPaddingtop: "100px", scrollMargintop: "-80px" }}>
                    <MREdata darkMode={darkMode}/>  
                </div> 
                 
                <div ref={NextRef} id="Adverisemet" className="container-fluid scroll-target pt-5 mt-5 "style={{ scrollPaddingtop: "100px", scrollMargintop: "-80px" }}> 
                    <Advertisement darkMode={darkMode}/> 
                </div>      

                <div ref={NextRef} id="Enquiry_Section" className="container-fluid d-flex justify-content-center align-items-center p-0 m-0 scroll-target" 
                    style={{ height: '100vh', overflow: 'hidden', scrollPaddingTop: '100px', scrollMarginTop: '50px' }}>
                    <Contact darkMode={darkMode}/>
                </div>
            </div>
        </div>
    );
}

export default Home;